import { CTA_L_TRAINS, CtaTrainLineIds, ctaMapToCityOfChicagoTrainId } from './constants';

// CTA Utils
export const CTADataType = {
    ROUTE: 'route',
    DESTINATION: 'destination',
    BUS_STOP: 'busStop',
    PREDICTION: 'prediction',
    TRAIN_STATION: 'trainStation',
    ARRIVAL: 'arrival'
};

export const isRouteCTATrain = (route) => {
    return CTA_L_TRAINS.map(r => r.routeId).includes(route);
};

export const getCtaTrainColor = (routeId) => {
    let trainId = routeId;
    if (CtaTrainLineIds.includes(routeId)) {
        trainId = ctaMapToCityOfChicagoTrainId.find(r => r.ctaId === routeId).routeId;
    }
    const foundTrain = CTA_L_TRAINS.find(train => train.routeId === trainId);
    return foundTrain.routeColor || '#000000';
};

// Generic Utils
export const between = (text, start, end) => {
    if (typeof text === 'string' || text instanceof String) {
        return text.substring(
            text.lastIndexOf(start) + 1,
            text.lastIndexOf(end)
        );
    }
    return "";
};

export const calculateTimeDifference = (date1, date2) => {
    const arrival = new Date(date1);
    const pred = new Date(date2);
    var milliTime = arrival - pred;
    const minute = Math.floor(milliTime/60000);
    return minute;
};

// hello World , 0, 1
export const upperCaseSubstring = (text, index, count) => {
    if (text && index < count) {
        const substring = text.toUpperCase();
        return substring.substring(index, index + count);
    }
    return "";
};


